import { asSequence } from "sequency"

/**
 * A function that simply returns its input as it is
 * @param {T} x - the input
 * @returns {T}
 */
const identity = x => x;

/**
 * Call a function with the provided arguments
 * @param  {...any} args - The arguments to pass
 * @returns {(f: Function) => any}
 */
const callWith = (...args) => f => f(...args);

/**
 * Extract (pluck) a specific property from an object
 * @param {string|Symbol} key - The key of the desired property
 * @returns {(obj: object) => any}
 */
const pluck = key => obj => obj[key];

/**
 * Extract (pluck) specific properties from an object
 * @param {(string|Symbol)[]} keys - The keys of the desired properties
 * @returns {(obj: object) => any[]}
 */
const pluckAll = (...keys) => obj => keys.map(key => pluck(key)(obj));

/**
 * Pick specific properties to keep on an object
 * @param  {...(string|Symbol)} keys - The keys of the desired properties
 * @returns {(obj: object) => object}
 */
const pick = (...keys) => obj => asSequence(keys)
								.map(pluck)
								.map(callWith(obj))
								.reduce(Object.assign);

/**
 * Pick specific properties to keep on an object
 * @param {object} obj - The object to scan
 * @param {(string|Symbol)} keys - The keys of the desired properties
 */
const withOnly = (obj, keys) => pick(...keys)(obj);

/**
 * Restrict the properties of an object
 * @param {object} obj - The object to scan
 * @returns {object}
 */
const restrict = obj => ({
	/**
	 * Extract the desired properties from the object
	 * @param {(string|Symbol)[]} keys - The keys of the desired properties
	 * @returns {object}
	 */
	to(keys){
		return withOnly(obj, keys);
	},
})

export {
	identity,
	callWith,
	pluck,
	pluckAll,
	pick,
	withOnly,
	restrict,
}